import React from "react";
import { defaultUrgencyBadges } from "../SidebarNavigation/utils/urgencyData";

class UrgencyBadges extends React.Component {
    render() {
        const items = this.props.items || defaultUrgencyBadges;
        return (
            <div className="urgency-badges-container" style={{ marginTop: '20px' }}>
                <div className="flex-row">
                    {items.map((it, i) => (
                        <span key={i} className={`in-context-badge`} style={{ ...it.style, fontFamily: "var(--font-body)" }}>
                            <span className="dot" />
                            {it.label}
                        </span>
                    ))}
                </div>
            </div>
        );
    }
}

export default UrgencyBadges;


// WEBPACK FOOTER //
// ./src/components/pages/in-context/components/UrgencyBadges.js